// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-nav-link[data-v-5d687836]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
